import { useEffect } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { CARD_FIELD_TYPE, defaultPrimitive } from "src/modules/pe-landing-module/data/interfaces"
import { CategoryLabelPrimitive } from "../../primitive"
import { ICardFieldProps } from "../cards/CardField"

/* Protopia Ecosystem component */
const CardFieldCategoryLabel = (props: ICardFieldProps): JSX.Element => {
    const { value, field, section, i } = props

    useEffect(() => { 
        addCSSClass(
            `landing-card-field-category-icon-${section.id + "-" + value?.id}`,
            `.landing-card-field-category-icon-${section.id + "-" + value?.id} {
                
            } 
            `
        )
        return () => removeCSSClass(`landing-card-field-category-icon-${section.id + "-" + value?.id}`)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) 

    const primitive = {
        ...defaultPrimitive(),
        ...field,
        ...value,
        type: CARD_FIELD_TYPE.CATEGORY_LABEL,
        data: {
            ...field.data,
            title: value.data || field.title,
        },
        style: { 
            width:  value.style?.width || field.width || 75,
            height: value.style?.height || field.height || 75,        
        },
        className: (field.className || "") + " " + " medallion-padder",
        width:  field.width  || 75,
        height: field.height || 75,     
        id: section.id + "-" + value?.id, 
    }
    return <div 
        className={`landing-card-field landing-card-field-category-icon ${value.className || ""}`} 
        style={{ ...field.style, ...value.style }} 
        data-card-field-id={i}
        card-field-section-id={section.id}
    > 
        <CategoryLabelPrimitive primitive={ primitive } /> 
    </div>
}
export default CardFieldCategoryLabel